import { render, staticRenderFns } from "./SuggestPackagingDgs.vue?vue&type=template&id=0cbeea47"
import script from "./SuggestPackagingDgs.vue?vue&type=script&lang=js"
export * from "./SuggestPackagingDgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports